import {TableRowHeight} from '../api/view/contracts'

export const SINGLE_TABLE_ROW_HEIGHT = 37

export const ROW_HEIGHT_VALUES: Record<TableRowHeight, number> = {
  [TableRowHeight.Single]: SINGLE_TABLE_ROW_HEIGHT,
  [TableRowHeight.Medium]: 56,
  [TableRowHeight.Tall]: 80,
  [TableRowHeight.ExtraTall]: 120,
}

export const ROW_HEIGHT_LABELS: Record<TableRowHeight, string> = {
  [TableRowHeight.Single]: 'Single',
  [TableRowHeight.Medium]: 'Medium',
  [TableRowHeight.Tall]: 'Tall',
  [TableRowHeight.ExtraTall]: 'Extra tall',
}

export const TABLE_ROW_LINE_HEIGHT_PX = 20

const SINGLE_TABLE_ROW_PADDING_Y = 12

/**
 * Intentional line-clamp presets per row height. These are design-specified values,
 * not dynamically computed from row height / line height.
 */
export const ROW_HEIGHT_LINE_CLAMP_VALUES: Record<TableRowHeight, number> = {
  [TableRowHeight.Single]: 1,
  [TableRowHeight.Medium]: 2,
  [TableRowHeight.Tall]: 3,
  [TableRowHeight.ExtraTall]: 5,
}

export function isTableRowHeight(rowHeight: unknown): rowHeight is TableRowHeight {
  return typeof rowHeight === 'string' && Object.values(TableRowHeight).includes(rowHeight as TableRowHeight)
}

export function getTableRowHeightLineClamp(rowHeight: TableRowHeight): number {
  return ROW_HEIGHT_LINE_CLAMP_VALUES[rowHeight]
}

export function getTableRowHeightPaddingY(rowHeight: TableRowHeight): number {
  if (rowHeight === TableRowHeight.Single) return SINGLE_TABLE_ROW_PADDING_Y

  const contentHeight = getTableRowHeightLineClamp(rowHeight) * TABLE_ROW_LINE_HEIGHT_PX
  return Math.max(0, Math.floor((ROW_HEIGHT_VALUES[rowHeight] - contentHeight) / 2))
}

export function getTableRowHeightAlignItems(rowHeight: TableRowHeight): 'center' | 'flex-start' {
  return rowHeight === TableRowHeight.Single ? 'center' : 'flex-start'
}
